import { Heading, Stack } from '@chakra-ui/react'
import React, { useContext } from 'react'
import AppCarosel from '../Components/AppCarosel'
import AuthContext from '../Routes/hooks/AuthContext'

function HomePage() {
	const carosel = [
		'https://images.dusdusan.com/product/LrnsKmHO1672123889_1672123888510.jpg',
		'https://images.dusdusan.com/product/2dt3Y3an1671097073_1671097073736.jpg',
		'https://images.dusdusan.com/product/dnynjaPf1671096833_1671096833774.jpg'
	]



	return (<>
			<AppCarosel images={carosel} />
			<Stack>
				<Heading>Ini apa ya?</Heading>
			</Stack></>
	)
}

export default HomePage